export default __webpack_public_path__ + "static/media/consumption.021bb75a.webp";